<template>
  <div id="config-manage" ref="container" class="grid-view" :class="showRight?'show-right':''">
    <div class="main-content left" style="height: 100%">
      <div class="app-main-inner-row">
        <div class="filters">
          <el-button type="primary" @click="editConfigItem()">{{ $t('CargoMsg.Cargo_EditConfigurationItem') }}</el-button>
          <span class="box-label" style="margin-left: 10px">{{ $t('CargoMsg.Cargo_EditConfigurationDefinition') }}</span>
        </div>
        <div class="triggers">
          <span>{{ $t('CargoMsg.Cargo_Search') }}</span>
          <el-input
            v-model="filter.likeName"
            :placeholder="$t('SystemMaintenance.PleaseConfigurationNameOrRemarks')"
            style="width: 200px;margin: 0 10px"
            @input="filter.pageNum=1;toQuery()"
          />
          <el-button v-if="this.$store.getters.tenantId === 1" type="primary" @click="showEditDialog(true)">{{ $t('common.btn.new') }}</el-button>
          <el-button v-if="this.$store.getters.tenantId === 1" type="primary" @click="showEditDialog(false)">{{ $t('common.btn.edit') }}</el-button>
          <el-button v-if="this.$store.getters.tenantId === 1" size="mini" type="danger" @click="remove">{{ $t('common.btn.delete') }}</el-button>
          <el-button
            size="mini"
            type="primary"
            @click="filter.pageNum=1;toQuery()"
          >{{ $t('common.btn.refresh') }}</el-button>
        </div>
      </div>
      <div class="section grid-wrapper" style="height: 90%">
        <cargo-ag-grid
          config-module="200102"
          :grid-params.sync="girdParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          v-show="total>0"
          config-module="2001021"
          :total="total"
          :page.sync="filterJson.pageNum"
          :limit.sync="filterJson.pageSize"
          @pagination="toQuery()"
        />
      </div>
    </div>
    <div class="division">
      &nbsp;
    </div>
    <configuration-management-sub
      class="right"
      :config-id="configId"
      :config-name="configName"
      style="height: 100%"
    />
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="500px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="90px" label-position="left">
          <el-form-item :label="$t('SystemMaintenance.Type')">
            <el-input v-model="editDialog.form.dataType" />
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.InterfaceSettings')">
            <el-radio-group v-model="editDialog.form.client">
              <el-radio :label="true">{{ $t('SystemMaintenance.Yes') }}</el-radio>
              <el-radio :label="false">{{ $t('SystemMaintenance.No') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="分公司选项">
            <el-radio-group v-model="editDialog.form.officeOption">
              <el-radio :label="true">{{ $t('SystemMaintenance.Yes') }}</el-radio>
              <el-radio :label="false">{{ $t('SystemMaintenance.No') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="服务设置">
            <el-radio-group v-model="editDialog.form.server">
              <el-radio :label="true">{{ $t('SystemMaintenance.Yes') }}</el-radio>
              <el-radio :label="false">{{ $t('SystemMaintenance.No') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="可选项">
            <el-input v-model="editDialog.form.literals" />
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.ConfigurationName')">
            <el-input v-model="editDialog.form.name" />
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.Remark')">
            <el-input v-model="editDialog.form.remarks" />
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.DefaultValue')">
            <el-input v-model="editDialog.form.value" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
        <el-button @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import configurationManagementSub from './configurationManagementSub'
import { getConfigDefList, saveConfigDef, delConfigDef } from '@/api/sysManage/baseConfig/configDef'

export default {
  name: 'ConfigurationManagement',
  components: { configurationManagementSub },
  data() {
    return {
      showRight: false,
      filterJson: {
        pageNum: 1,
        pageSize: 50
      },
      filter: {
        likeName: '',
        pageNum: 1,
        pageSize: 50
      },
      total: 0,
      girdParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        onRowClicked: event => {
          this.configId = String(event.data.configId)
          this.configName = event.data.name
        },
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: this.$t('SystemMaintenance.ConfigurationItemconfigId'),
          field: 'configId',
          width: 150
        },
        {
          headerName: this.$t('SystemMaintenance.TypedataType'),
          field: 'dataType',
          width: 150
        },
        {
          headerName: this.$t('SystemMaintenance.InterfaceSettingsisClient'),
          field: 'client',
          width: 150
        },
        {
          headerName: this.$t('SystemMaintenance.BranchOfficeOptionisOfficeOption'),
          field: 'officeOption',
          width: 150
        },
        {
          headerName: this.$t('SystemMaintenance.ServiceSettingsisServer'),
          field: 'server',
          width: 150
        },
        {
          headerName: this.$t('SystemMaintenance.OptionalItemliterals'),
          field: 'literals',
          width: 150
        },
        {
          headerName: this.$t('SystemMaintenance.ConfigurationNamename'),
          field: 'name',
          width: 200
        },
        {
          headerName: this.$t('SystemMaintenance.Remarksremarks'),
          field: 'remarks',
          width: 200
        },
        {
          headerName: this.$t('SystemMaintenance.DefaultValuevalue'),
          field: 'value',
          width: 150
        }
      ],
      rowData: [],
      editDialog: {
        visible: false,
        title: '',
        initialForm: null,
        form: {
          uuid: '',
          dataType: '',
          client: false,
          officeOption: false,
          server: false,
          literals: '',
          name: '',
          remarks: '',
          value: ''
        }
      },
      configId: '',
      configName: ''
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    }
  },
  created() {
    this.toQuery()
    this.editDialog.initialForm = this.editDialog.form
  },
  methods: {
    toQuery() {
      let params = {}
      params = { ... this.filter }
      params.likeName = params.likeName.trim()
      params.pageNum = this.filterJson.pageNum
      params.pageSize = this.filterJson.pageSize
      getConfigDefList(params).then(res => {
        if (this.gridApi) {
          this.gridApi.setRowData(res.data.list)
        } else {
          this.rowData = res.data.list
        }
        this.total = Number(res.data.total)
      })
    },
    showEditDialog(isNew) {
      if (isNew) {
        this.editDialog.form = { ...this.editDialog.initialForm }
        this.editDialog.title = this.$t('common.btn.new')
      } else {
        const cell = this.gridOptions.api.getFocusedCell()
        const nodes = this.gridOptions.api.rowModel.rowsToDisplay
        const selectedRow = cell ? nodes.find(node => node.rowIndex === cell.rowIndex).data : null
        if (!selectedRow) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        const form = { ...selectedRow }
        this.editDialog.form = form
        this.editDialog.title = this.$t('common.btn.edit')
      }
      this.editDialog.visible = true
    },
    save() {
      const form = this.editDialog.form
      if (!form.name) {
        this.$message.warning(this.$t('SystemMaintenance.ConfigurationNameCannotBeEmpty'))
        return
      }
      if (!form.value) {
        this.$message.warning(this.$t('SystemMaintenance.DefaultValueCannotBeEmpty'))
        return
      }
      if (form.name) {
        form.name = form.name.trim()
      }
      if (form.value) {
        form.value = form.value.trim()
      }
      saveConfigDef(form).then(res => {
        if (!form.uuid) {
          this.filter.pageNum = 1
        }
        this.toQuery()
        this.editDialog.visible = false
        this.$message.success(this.$t('common.tips.saveSuccess'))
      })
    },
    remove() {
      const cell = this.gridOptions.api.getFocusedCell()
      const nodes = this.gridOptions.api.rowModel.rowsToDisplay
      const selectedRow = cell ? nodes.find(node => node.rowIndex === cell.rowIndex).data : null
      if (!selectedRow) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.$confirm(this.$t('common.tips.confirmDelete'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        delConfigDef(selectedRow.uuid).then(res => {
          this.filter.pageNum = 1
          this.toQuery()
          this.$message.success(this.$t('common.tips.deleteSuccess'))
        })
      }).catch(() => { })
    },
    editConfigItem() {
      const cell = this.gridOptions.api.getFocusedCell()
      const nodes = this.gridOptions.api.rowModel.rowsToDisplay
      const selectedRow = cell ? nodes.find(node => node.rowIndex === cell.rowIndex).data : null
      if (!selectedRow) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.showRight = !this.showRight
    }
  }
}
</script>

<style lang="scss">
#config-manage {
  padding-bottom: 10px;
  .left {
    min-width: 300px;
  }
  .division {
    display: none;
  }
  .right {
    display: none;
  }
  .box {
    position: relative;
    padding-top: 10px;
    .box-label {
      position: absolute;
      left: 10px;
      top: 0;
      padding: 0 5px;
      border-radius: 3px;
      font-size: 13px;
      line-height: 20px;
      background: #f5f7fa;
      color: #404144;
    }
    .box-content {
      width: 100%;
      border: 1px solid #ababab;
      border-radius: 5px;
      padding: 0;
      padding-top: 10px;
    }
  }
  .app-main-inner-row {
    padding: 8px;
  }
  .row-pagination {
    display: block;
    overflow-x: auto;
  }
  .el-form-item__content {
    width: 170px;
  }
  .el-dialog {
    .el-form-item__content {
      width: 300px;
    }
  }
  .el-button {
    margin-left: 1px;
  }
  .el-button--mini {
    padding: 7px 12px;
  }
}
#config-manage.show-right {
  display: block;
  float: left;
  width: 100%;
  min-width: 610px;
  overflow-x: auto;
  .left {
    display: block;
    float: left;
    width: calc(50% - 6px);
  }
  .division {
    display: table;
    float: left;
    width: 10px;
  }
  .right {
    display: block;
    float: left;
    width: calc(50% - 6px);
    min-width: 300px;
  }
}
</style>
